export default __webpack_public_path__ + "static/media/hero-l.dc2f9f54.jpg";